module.exports = __webpack_public_path__ + "img/app-services.310cd038.jpg";